<template>
  <FormGroup :error-container="errorContainer" :label="label" :name="name" :floating="floating">
    <FmSelect :value="proxyValue" :options="options" :icons="icons" :disabled="disabled"
              @input="proxyValue = $event"/>
  </FormGroup>
</template>

<script>
import FormGroup from '@modules/shared/components/form/FormGroup';
import FmSelect from '@modules/shared/components/form/FmSelect';
import {IDVerificationDocumentTypes} from '@modules/guest/bought-lead/constants';

const ICONS = {
  passport: `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm9 1.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5zM9 8a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 0-1h-4A.5.5 0 0 0 9 8zm1 2.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5zM7 5C7 3.343 5.657 2 4 2s-3 1.343-3 3 1.343 3 3 3 3-1.343 3-3zm1 7c0-1.01-.377-2.042-1.09-2.904C6.105 8.365 5.114 8 4 8c-1.114 0-2.105.365-2.91 1.096C.376 9.958 0 10.99 0 12h8z"/></svg>`,
  license:  `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M11.5 5.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V6a.5.5 0 0 1 .5-.5h3zM.5 0h15a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5V.5A.5.5 0 0 1 .5 0zM1 1v14h14V1H1zm7 4.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0zm-4.5 5c0 .5.5 1 1.5 1h2c1 0 1.5-.5 1.5-1 0-1-1-2-2.5-2S3.5 9.5 3.5 10.5z"/></svg>`,
};

export default {
  name: 'IDVerificationSelect',
  components: { FormGroup, FmSelect },
  model: { prop: 'value', event: 'input' },
  props: {
    name:           { type: String,  default: 'documentType' },
    label:          { type: String,  default: 'ID Verification' },
    value:          { type: String,  default: '' },
    disabled:       { default: false },
    errorContainer: { type: String,  default: '' },
    floating:       { type: Boolean, default: false },
  },
  computed: {
    options: () => IDVerificationDocumentTypes,
    icons:   () => ICONS,
    proxyValue: {
      get() { return this.value; },
      set(v) { this.$emit('input', v); },
    },
  },
};
</script>
